import axios from 'axios'
import { API_ROOT } from '../constants'

export const sendOTP = async (email) => {
  const endpoint = `${API_ROOT}/ext/api/v3/otp/request`
  const { data } = await axios.post(endpoint, { email })
  return data
}

export const verifyOTP = async (email, otp) => {
  const { data } = await axios.post(`${API_ROOT}/ext/api/v3/otp/verify`, {
    email,
    otp,
    authResponseType: 'token'
  })
  return data
}

export const processTiinyTransfer = async (formData) => {
  const headers = { 'Content-Type': 'multipart/form-data' }
  const token = localStorage.getItem('token')
  if (token) {
    headers['Authorization'] = `Bearer ${token}`
  }

  const { data } = await axios.post(`${API_ROOT}/v3/tiiny-transfer`, formData, {
    headers
  })
  return data
}
